// New version src/Common/controls/control/validation/validation.component.ts CommonValidationComponent
// Old version src/CaseDotStar.ServicePackages.Frontend.Common/scripts/common/widgets/validation_component_service.jsx ValidationComponent

import {
	ChangeDetectionStrategy,
	Component,
	Input,
	Injector,
} from '@angular/core';

import {
	NgModel,
	NgForm,
} from '@angular/forms';

import {
	forEach,
	isBoolean,
	get,
} from 'lodash';
import { ICommonKeyValues } from '../../../@types/core';

import { CommonBaseComponent } from '../../../components/base.component';
import { DEFAULT_ERROR_MESSAGES } from './default_error_messages.constant';

export interface ICommonValidationComponentCustomErrors {
	[errorName: string]: string;
}

export interface ICommonValidationComponentError {
	message: string;
	context: ICommonKeyValues;
}

export type TCommonValidationComponentError = ICommonValidationComponentError | boolean;

@Component({
	selector: 'common-validation',
	templateUrl: './validation.component.pug',
	changeDetection: ChangeDetectionStrategy.OnPush,
	styleUrls: [
		'./validation.component.sass',
	],
})
export class CommonValidationComponent extends CommonBaseComponent {
	@Input() customErrors: ICommonValidationComponentCustomErrors;
	@Input() ngModelControl: NgModel;
	@Input() isShow = true;

	constructor (protected injector: Injector) {
		super(injector);
	}

	ngOnInit () {
		if (this.ngModelControl) {
			this.subscribe(this.ngModelControl.update, () => {
				this.runUpdate();
			});

			this.subscribe(this.ngModelControl.control.statusChanges, () => {
				this.runUpdate();
			});

			if (this.ngModelControl.formDirective) {
				this.subscribe(this.ngModelControl.formDirective.ngSubmit, () => {
					this.runUpdate();
				});
			}
		}
	}

	getMessage (): string {
		let result = '';

		if (this.ngModelControl && this.isShow) {
			const formDirective: NgForm = this.ngModelControl.formDirective;

			if (formDirective && formDirective.submitted && !this.ngModelControl.valid) {
				forEach(this.ngModelControl.errors, (val: TCommonValidationComponentError, errorName) => {
					if (!val) {
						return;
					}

					let message = DEFAULT_ERROR_MESSAGES[errorName];
					let context = {};

					if (!isBoolean(val)) {
						context = val.context || context;
						message = val.message || message;
					}

					 // условие необходимо для показа тултипов только при заполненных полях (false для booleanCheckbox, 0 для текстфилда)
					if (this.ngModelControl.model || [null, false, 0].indexOf(this.ngModelControl.model) >= 0) {
						message = get(this.customErrors, errorName) || message;

						if (message) {
							message = this.instant(message, context);

							result = message || result;
						}
					} else {
						message = null;
					}

					return false;
				});
			}
		}

		return result;
	}
}
